import { translate } from '@/core/localization/translate';
export const {
  title,
  subtitle
} = translate({
  "title": "Take a look",
  "subtitle": "There's so much more to see"
});